import React, { useEffect, useState } from 'react'
import { Link, useLocation} from 'react-router-dom'
// Logo from public folder
const logo = "/assets/images/logo.png";



function Main() {

    const [headerScroll, setheaderScroll] = useState(false)
    const [mobile, setmobile] = useState()
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {


        const fixedHeader = () => {
            if (window.pageYOffset > 150) {
                setheaderScroll(true)
            } else {
                setheaderScroll(false)
            }
        }
        window.addEventListener('scroll', fixedHeader)
    }, [])
    const [openDropdown, setOpenDropdown] = useState(null);
      const toggleDropdown = (index) => {
          setOpenDropdown(openDropdown === index ? null : index);
      };

    return (
        <>
            <header className={headerScroll ? "fixed fix_style" : "fixed"} >
                <div className="container">
                    <nav className="navbar navbar-expand-lg">
                        <Link className="navbar-brand" to="#">
                            <img src={logo} alt="Logo" />
                        </Link>
                        <button className={`navbar-toggler ${mobile && "collapsed"}`} onClick={() => setmobile(mobile === true ? false : true)} type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <div className={`toggle-wrap ${mobile && "active"}`} onClick={() => setmobile(mobile === true ? false : true)}>
                                <span className="toggle-bar"></span>
                            </div>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                <li className={`nav-item ${['/', '/home'].includes(currentPath) ? 'active' : ''}`}>
                                    <Link className="nav-link" to="/">
                                        Acasă
                                    </Link>
                                </li>
                                <li className={`nav-item ${['/business'].includes(currentPath) ? 'active' : ''}`}>
                                    <Link className="nav-link" to="/business">
                                        Business
                                    </Link>
                                </li>
                                <li className={`nav-item ${['/about', '/about-us'].includes(currentPath) ? 'active' : ''}`}>
                                    <Link className="nav-link" to="/about">
                                        Despre noi
                                    </Link>
                                </li>
                                <li className={`nav-item ${['/blog'].includes(currentPath) ? 'active' : ''}`}>
                                    <Link className="nav-link" to="/blog">
                                        Blog
                                    </Link>
                                </li>
                                <li className={`nav-item ${['/contact'].includes(currentPath) ? 'active' : ''}`}>
                                    <Link className="nav-link" to="/contact">
                                        Contact
                                    </Link>
                                </li>
                                <li className="nav-item has_dropdown">
                                    <Link className="nav-link" to="#"  onClick={() => toggleDropdown(1)}>
                                        Pagini
                                    </Link>
                                    <span className="drp_btn ">
                                        <i className="icofont-rounded-down" onClick={() => toggleDropdown(1)}/>
                                    </span>
                                    {openDropdown === 1 && (
                                    <div className="sub_menu show" data-aos="fade-up" data-aos-duration={1500}>
                                        <ul>
                                            <li className={`nav-item ${['/blog'].includes(currentPath) ? 'active' : ''}`}>
                                                <Link to="/blog">Blog - Listă</Link>
                                            </li>
                                            <li className={`nav-item ${['/blog-post'].includes(currentPath) ? 'active' : ''}`}>
                                                <Link to="/blog-post">Blog - Postare</Link>
                                            </li>
                                            <li>
                                                <Link to="/sign-in">Autentificare</Link>
                                            </li>
                                            <li>
                                                <Link to="/sign-up">Înregistrare</Link>
                                            </li>
                                            <li className={`nav-item ${['/pricing'].includes(currentPath) ? 'active' : ''}`}>
                                                <Link to="/pricing">
                                                    Prețuri
                                                </Link>
                                            </li>
                                            <li className={`nav-item ${['/reviews'].includes(currentPath) ? 'active' : ''}`}>
                                                <Link to="/reviews">
                                                    Recenzii
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    )}
                                </li>
                                <li className="nav-item">
                                    <div className="btn_block">
                                        <Link className="nav-link dark_btn" to="/contact">
                                            Programează-te acum <i className="icofont-arrow-right" />
                                        </Link>
                                        <div className="btn_bottom" />
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {mobile &&
                            <>
                                <div className={`navbar-collapse collapse ${mobile && "show"}`} id="navbarSupportedContent" style={{}} >
                                    <ul className="navbar-nav ml-auto">
                                        <li className={`nav-item ${['/', '/home'].includes(currentPath) ? 'active' : ''}`}>
                                            <Link className="nav-link" to="/">
                                                Acasă
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${['/business'].includes(currentPath) ? 'active' : ''}`}>
                                            <Link className="nav-link" to="/business">
                                                Business
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${['/about', '/about-us'].includes(currentPath) ? 'active' : ''}`}>
                                            <Link className="nav-link" to="/about">
                                                Despre noi
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${['/blog'].includes(currentPath) ? 'active' : ''}`}>
                                            <Link className="nav-link" to="/blog">
                                                Blog
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${['/contact'].includes(currentPath) ? 'active' : ''}`}>
                                            <Link className="nav-link" to="/contact">
                                                Contact
                                            </Link>
                                        </li>
                                        <li className="nav-item has_dropdown">
                                            <Link className="nav-link" to="#"  onClick={() => toggleDropdown(1)}>
                                                Pagini
                                            </Link>
                                            <span className="drp_btn ">
                                                <i className="icofont-rounded-down" onClick={() => toggleDropdown(1)}/>
                                            </span>
                                            {openDropdown === 1 && (
                                            <div className="sub_menu show">
                                                <ul>
                                                    <li className={`nav-item ${['/blog'].includes(currentPath) ? 'active' : ''}`}>
                                                        <Link to="/blog">Blog - Listă</Link>
                                                    </li>
                                                    <li className={`nav-item ${['/blog-post'].includes(currentPath) ? 'active' : ''}`}>
                                                        <Link to="/blog-post">Blog - Postare</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/sign-in">Autentificare</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/sign-up">Înregistrare</Link>
                                                    </li>
                                                    <li className={`nav-item ${['/pricing'].includes(currentPath) ? 'active' : ''}`}>
                                                        <Link to="/pricing">Prețuri</Link>
                                                    </li>
                                                    <li className={`nav-item ${['/reviews'].includes(currentPath) ? 'active' : ''}`}>
                                                        <Link to="/reviews">Recenzii</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            )}
                                        </li>

                                        <li className="nav-item">
                                            <div className="btn_block">
                                                <Link className="nav-link dark_btn" to="/contact">
                                                    Programează-te acum <i className="icofont-arrow-right" />
                                                </Link>
                                                <div className="btn_bottom" />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </>
                        }
                    </nav>
                </div >
            </header>
        </>
    )
}

export default Main